import * as React from 'react';
import { MobilePage } from '../../components/MobilePage';
import { Page } from '../../components/Page';
import { EDeviceType } from '../../types/device';

export const PageComponent = ({ deviceType }: { deviceType: EDeviceType }) => {
  return deviceType === EDeviceType.Desktop ? <Page /> : <MobilePage />;
};
